import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, allEqual, first, any, toObservable } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { PagoRealizado } from "../../../pago/index";

type Entity = models.EntregaOcurreModel;

export interface Props {
    value: Entity;
    guias: models.GuiaDTO[];
    onChange: (value: Entity) => PromiseLike<void> | void;
    onAceptar: () => void;

}

/**
* Componente para editar un Entity
*/
class PagoEntregaOcurreNoRx extends React.PureComponent<Props> {
    loadFunction = kea.loadItemsFuncFromResource(() => [], resources.Guia.Get, x => x.Folio, x => true);
    guias = (props: Props) => props.guias;
    value = (props: Props) => props.value;
    pago = createSelectorRx(this.value, x => x.PagoRealizado);

    guiasOcupanAutorizado = createSelectorRx(this.guias, guias => any(guias, x => x.RequiereContactoAutorizado));

    /**El idCliente es el cliente de la primera guia, ya que solo se permite entregar varias guias del mismo cliente */
    idCliente = createSelectorRx(this.guias, x => first(x.map(x => x.IdClienteDestino)));
    idDireccionClienteDestino = createSelectorRx(this.guias, x => first(x.map(x => x.IdDireccionClienteDestino)));

    guiasFXC = createSelectorRx(this.guias, x => x.filter(guia => guia.FletePorCobrar));
    /**Importe a pagar */
    total = createSelectorRx(this.guiasFXC, guias => guias.map(x => x.Importes ? x.Importes.Total : 0).reduce((a, b) => a + b, 0));
    mismoDestino = createSelectorRx(this.guias, guias => allEqual(guias.map(x => x.IdDireccionClienteDestino)));
    sinGuias = createSelectorRx(this.guias, guias => guias.length == 0);
    entregadas = createSelectorRx(this.guias, guias => any(guias, x => x.Entregada));

    idContacto = (props: Props) => props.value.IdContactoCliente;
    contacto = createSelectorRx(this.idContacto, id => toObservable(id == null ? id : observeResource(resources.ContactoCliente.Get, id)));
    errorContacto = createSelectorRx(this.contacto, this.guiasOcupanAutorizado, (contacto, ocupaAutoriz) => {
        if (contacto == null)
            return "Contacto receptor obligatorio";
        else if (ocupaAutoriz && !contacto.AutorizadoRecibir) {
            return "Contacto no autorizado para recibir paquetes";
        }
        return undefined;
    });

    erroresGuias = createSelectorRx(this.mismoDestino, this.entregadas, this.sinGuias,
        (mismoDestino, entregadas, sinGuias) =>
            mismoDestino == false ? "Todas las guias deben de estar dirigidas al mismo destino" :
                entregadas ? "Algunas guias ya fueron entregadas" :
                    sinGuias ? "No hay guias seleccionadas" : undefined
    );

    errorPago = createSelectorRx(this.errorContacto, this.erroresGuias, (errContacto, errGuias) => errGuias || errContacto);

    onPagoChange = (pago: models.PagoRealizadoModel) => {
        this.props.onChange({ ... this.props.value, PagoRealizado: pago });
    }

    onContactoChange = (idContactoCliente: number) => {
        this.props.onChange({ ... this.props.value, IdContactoCliente: idContactoCliente });
    }

    render() {
        const importeTotal = this.total(this.props);
        const idCliente = this.idCliente(this.props);
        const error = this.errorPago(this.props);
        const ocupaAutoriz = this.guiasOcupanAutorizado(this.props);
        const pago = this.pago(this.props);
        const idDireccionClienteDestino = this.idDireccionClienteDestino(this.props);

        return (
            <div>
                <div className="row">
                    <div className="col-md-6">
                        <selectores.Contacto
                            idDireccion={idDireccionClienteDestino}
                            value={this.props.value.IdContactoCliente}
                            onChange={this.onContactoChange}
                            label="Contacto receptor"
                        />
                    </div>
                </div>


                <PagoRealizado
                    error={error}
                    idCliente={idCliente}
                    importeAPagar={importeTotal}
                    value={pago}
                    onChange={this.onPagoChange}
                    onAceptar={this.props.onAceptar}
                    verPagoContado={true}
                    verPagoCredito={true}
                />
            </div>
        )


    }
}

export const PagoEntregaOcurre = componentToRx(PagoEntregaOcurreNoRx);


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/ocurre/componentes/pago/index.tsx